exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".rkwJOQLHZpFv2jmAmHO8M{width:100%;height:40px;margin-right:auto;margin-top:10px;display:flex;justify-content:flex-start}._2MoP2GBkNxKY1R0gXlT5ax{flex:0 1 33%}\n", ""]);

// Exports
exports.locals = {
	"CTAs": "rkwJOQLHZpFv2jmAmHO8M",
	"followCTA": "_2MoP2GBkNxKY1R0gXlT5ax"
};